import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

// hooks
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// components
import Button from "common/button";
import screenSize from "utils/screenSize";
import {
  BannerTitle,
  BannerContent,
  BannerIcon,
  BannerTextAndButton,
} from "./styles";

const BookAClassBanner = () => {
  const { t } = useTranslation("class_banner");
  const navigate = useNavigate();

  const handleClick = () => navigate("/book-class");

  const faQuestionCircleIconProp = faQuestionCircle as IconProp;

  return (
    <div>
      <BannerContent>
        <BannerIcon>
          <FontAwesomeIcon icon={faQuestionCircleIconProp} size="2x" />
        </BannerIcon>
        <BannerTextAndButton>
          <BannerTitle>
            {t("You have no classes booked at the moment.")}
          </BannerTitle>
          {screenSize() === "desktop" && (
            <Button
              name="bannerButton"
              type="primary"
              onClick={() => handleClick()}
            >
              {t("BOOK A CLASS NOW").toUpperCase()}
            </Button>
          )}
        </BannerTextAndButton>
      </BannerContent>

      {screenSize() === "mobile" && (
        <div>
          <br />
          <Button
            name="bannerButton"
            type="primary"
            onClick={() => handleClick()}
          >
            {t("BOOK A CLASS NOW").toUpperCase()}
          </Button>
        </div>
      )}
    </div>
  );
};

export default BookAClassBanner;
